import countries from 'i18n-iso-countries'
import * as Sentry from '@sentry/react'

const loadedLocales = new Set<string>()

/**
 * Loads country locale data on demand (lazy loading)
 * @param language - Language code (e.g. 'en', 'pl')
 */
export const loadCountryData = async (language = 'en') => {
  // Skip if already loaded
  if (loadedLocales.has(language)) {
    return
  }

  try {
    let localeData
    const loadedLanguage = language

    switch (language) {
      case 'en':
        localeData = await import('i18n-iso-countries/langs/en.json')
        break
      case 'pl':
        localeData = await import('i18n-iso-countries/langs/pl.json')
        break
      case 'de':
        localeData = await import('i18n-iso-countries/langs/de.json')
        break
      case 'zh':
        localeData = await import('i18n-iso-countries/langs/zh.json')
        break
      case 'pt':
        localeData = await import('i18n-iso-countries/langs/pt.json')
        break
      case 'es':
        localeData = await import('i18n-iso-countries/langs/es.json')
        break
      default:
        // Fallback to English for unsupported languages
        localeData = await import('i18n-iso-countries/langs/en.json')
    }

    const dataToRegister = localeData.default || localeData
    countries.registerLocale(dataToRegister)

    // Mark both the requested language and the actually loaded language as loaded
    // This prevents re-loading English for every unsupported language
    loadedLocales.add(language)

    if (loadedLanguage !== language) {
      loadedLocales.add(loadedLanguage)
    }
  } catch (error) {
    Sentry.captureException(error)
  }
}

// Load English by default
loadCountryData('en')

// eslint-disable-next-line import/no-default-export
export default countries
